module.exports = __webpack_public_path__ + "static/media/14UNEP25.c2a74623.jpg";